import React, { PureComponent } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faTimes,
  faTimesCircle,
  faChartLine,
  faCompressArrowsAlt,
  faStar,
  faChartBar,
  faSearchDollar,
  faUser,
  faUsers,
  faFolderOpen,
  faChevronUp,
  faChevronDown,
  faHandHoldingUsd,
} from '@fortawesome/free-solid-svg-icons'

import './AppBarNoAccess.css'

library.add(
  faPlus,
  faTimes,
  faTimesCircle,
  faChartLine,
  faCompressArrowsAlt,
  faStar,
  faChartBar,
  faSearchDollar,
  faUser,
  faUsers,
  faFolderOpen,
  faChevronUp,
  faChevronDown,
  faHandHoldingUsd,
);

class AppBarNoAccess extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showPrivate: false,
    };
  }

  getIcon(name) {
    switch (name) {
      case 'portfolio-analysis':
        return 'Money.svg'
      case 'performance-at-a-glance':
        return 'Pie-Chart-Alt.svg'
      case 'performance-at-a-glance':
        return 'Line-Chart.svg'
      case 'dailyperf':
        return 'arrow-right.svg'
      case 'shortlevfaq':
        return 'Sun.svg'
      case 'ecocal':
        return 'Pillow-Chart-1.svg'
      case 'shortlevsim':
        return 'Pillow-Chart-2.svg'
      default:
        return '';
    }
  }
  mouseOn() {
    this.setState({
      showPrivate: true,
    });
  }

  mouseOff() {
    this.setState({
      showPrivate: false,
    });
  }
  render() {
    const {
      title,
      description,
      name,
      divId,
      activeApp,
      link,
      message,
    } = this.props;

    const {
      showPrivate,
    } = this.state;

    let appStyle = 'naBarStyle';
    let columnClass = 'col-md-4';
    let iconHolderStyle = 'iconHolderStyle';
    let titleStyle = 'titleStyle';
    let aniStyle = 'aniStyle';
    let closeStyle = 'closeStyle';
    let iconStyle = 'iconStyle';

    return (
      <div className={columnClass + ' ' + aniStyle}>
        {showPrivate &&
          <div className={'naInfo'} onMouseLeave={() => this.mouseOff()}>
            {activeApp === name &&
              <div className={closeStyle}>&nbsp;</div>
            }
            {activeApp === '' &&
              <div className={closeStyle}>&nbsp;</div>
            }
            <div className={iconHolderStyle}><img className={iconStyle} src={`${process.env.REACT_APP_BASE_URL}/icons/${this.getIcon(name)}`} /></div>
            <div className={titleStyle}>{message}</div>
            {(activeApp !== name) &&
              <div className={'descriptionStyle'}>
                <a href={`/sign-in?redirect=${link}`}>Sign In</a>
                <a href={`/registration/my-profile?redirect=${link}`}>Register</a>
              </div>
            }
          </div>
        }
        {!showPrivate &&
          <div className={appStyle} onMouseEnter={() => this.mouseOn()}>
            {activeApp === name &&
              <div className={closeStyle}>&nbsp;</div>
            }
            {activeApp === '' &&
              <div className={closeStyle}>&nbsp;</div>
            }
            <div className={iconHolderStyle}><img className={iconStyle} src={`${process.env.REACT_APP_BASE_URL}/icons/${this.getIcon(name)}`} /></div>
            <div className={titleStyle}>{title}</div>
            {(activeApp !== name) &&
              <div className={'descriptionStyle'}>{description}</div>
            }
          </div>
        }
        <div className={'appOffStyle'} id={divId}></div>
      </div>
    );
  }
}

export default (AppBarNoAccess);


// WEBPACK FOOTER //
// ./src/components/App/AppBarNoAccess.js